import React, { useEffect, useState, lazy } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import FormInput from "../../components/formInput/FormInput";
import "./loginPage.styles.scss";
import PasswordField from "../../components/formInput/PasswordField/PasswordField";
import { toast } from "react-toastify";
import { useStateValue } from "../../store/state";
import { injectStyle } from "react-toastify/dist/inject-style";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import { AGREETERMS, CHECKTERMS, FORGOTPASSWORD, LOGINUSERINFO, TOKENUSERINFO } from "../../store/Login/Action";
import { browserName, browserVersion } from 'react-device-detect';
import LoginComponent from "../../components/LoginComponent/LoginComponent";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ResetPassword from "../ResetPassword/ResetPassword";
import liff from '@line/liff';
import axios from 'axios';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import FacebookLogin from 'react-facebook-login';
import request from "../../request";
import Thailand from '../../assets/images/flag/thailand.webp'
import English from '../../assets/images/flag/United_Kingdom.png'

function LoginPage() {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [alert, setAlert] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [chooselang, setChooseLang] = useState(() => {
    const storedLanguage = localStorage.getItem('storeid')
    return storedLanguage ? parseInt(storedLanguage, 10) : 2; // Default to 2 if not found
  });

  const [checkingTerms, setCheckingTerms] = useState(false)
  const [emailModal, setEmailModal] = useState(false)
  const [emailModalValidation, setEmailModalValidation] = useState("")
  const [getEmail, setGetEmail] = useState("")
  const [{ }, dispatch] = useStateValue();
  const { id, tok } = useParams()
  const [selectedCountry, setSelectedCountry] = useState('');
  const currenturl = window.location.origin;

  const GoogleCustomButton = () => {
    const login = useGoogleLogin({
      onSuccess: responseGoogle,
      onError: handleGoogleFailure,
    });

    return (
      <button onClick={() => login()} className="social-btn">
        <img
          src="https://developers.google.com/identity/images/g-logo.png"
          alt="Google"
          style={{ width: 18, height: 18 }}
        />
      </button>
    );
  };


  // Define handleLineLogin function here
  const handleLineLogin = async () => {
    try {
      await liff.init({ liffId: request.REACT_APP_LINE_LIFF_ID });
      if (!liff.isLoggedIn()) {
        await liff.login({
          scope: "openid profile email",
          redirectUri: request.REACT_APP_LINE_CALLBACK_URL,
        });
        return;
      } else {
        const token = liff.getIDToken();
        if (token) {
          // Send token via query param
          window.location.href = `${request.REACT_APP_LINE_CALLBACK_URL}?id_token=${token}`;
        } else {
          // Fallback: force re-login
          await liff.logout();
          window.location.reload();
        }
      }
    } catch (err) {
      console.error("catch LINE login failed:", err);
    }
  };

  const handleGoogleFailure = (error) => {
    console.log('Google login failed:', error);
    // You can show a message to the user or redirect
    history.push("/login");
    toast.error("Google login failed");
  };

  // // Google login response handler
  const responseGoogle = async (response) => {
    if (!response?.credential) {
      console.log("Google login response missing tokenId or credential:", response);
      return;
    }
    const tokenId = response.credential; // The ID token from Google login

    try {
      // Node API call here to Google Token verification
      const response = await axios.post(
        request.googleLoginTokenVerification,
        { id_token: tokenId }
      );

      console.log('Google login response:', response);

      const success = response?.data?.success;
      const data = response?.data?.data;

      if (success === true && data?.token) {
        await TOKENUSERINFO(dispatch, data.token, history, setShow, { checkTerms: true });
      } else {
        toast.error("Google login failed");
      }
    } catch (error) {
      console.error("catch google login error", error);
      history.push("/login");
      toast.error("Google login failed");
    }
  };

  // Facebook login response handler
  const responseFacebook = async (response) => {
    console.log('Facebook login response:', response);
    if (!response?.accessToken) {
      console.log("Facebook login response missing accessToken:", response);
      return;
    }
    const accessToken = response.accessToken; // The access token from Facebook login

    try {
      // Node API call here to Google Token verification
      const response = await axios.post(
        request.faceBookLoginTokenVerification,
        { id_token: accessToken }
      );

      console.error('Facebook login response:', response);

      const success = response?.data?.success;
      const data = response?.data?.data;

      if (success === true && data?.token) {
        await TOKENUSERINFO(dispatch, data.token, history, setShow, { checkTerms: true });
      } else {
        toast.error("Facebook login failed");
      }
    } catch (error) {
      console.error("catch Facebook login error", error);
      history.push("/login");
      toast.error("Facebook login failed");
    }
  };

  const [errors, seterrors] = useState({
    username: "",
    password: "",
  });

  // Reapply error messages in the current language
  useEffect(() => {
    seterrors((prevErrors) => ({
      username: prevErrors?.username ? t("Please enter your username") : "",
      password: prevErrors?.password ? t("Please enter your password") : "",
    }));
  }, [chooselang, t]);


  // LOGIN SUBMIT HANDLER AND LOGIN API CALL
  const SubmitHandler = async (e) => {
    e.preventDefault();
    if (username?.length === 0) {
      seterrors((data) => ({
        ...data,
        username: t("Please enter your username"),
      }));
    } else {
      seterrors((data) => ({
        ...data,
        username: "",
      }));
    }

    if (password?.length === 0) {
      seterrors((data) => ({
        ...data,
        password: t("Please enter your password"),
      }));
    } else {
      seterrors((data) => ({
        ...data,
        password: "",
      }));
    }

    if (username?.length === 0 || password?.length === 0) return;
    LOGINUSERINFO(dispatch, username, password, toast, history, setShow)
  };

  const termsCheck = (value) => {
    setCheckingTerms(value)
  }

  useEffect(() => {
    if (emailModal) {
      setGetEmail("")
      setEmailModalValidation("")
    }
  }, [emailModal])

  useEffect(() => {
    if (localStorage.getItem('showTermsOnLoad') === 'true') {
      localStorage.removeItem('showTermsOnLoad');
      // tempLoginData should have been set by TOKENUSERINFO before redirecting
      if (localStorage.getItem('tempLoginData')) {
        setShow(true);
      }
    }
  }, []);

  useEffect(() => {
    // Check if there's a stored language in local storage
    const storedLanguage = localStorage.getItem('storeid');

    // If there's a stored language, use it
    if (storedLanguage) {
      if (storedLanguage == 1) {
        i18n.changeLanguage("en");
      } else if (storedLanguage == 2) {
        i18n.changeLanguage("th");
      }
    } else {
      // If no stored language, use the default logic based on chooselang
      if (chooselang == 1) {
        i18n.changeLanguage("en");
      }
      if (chooselang == 2) {
        i18n.changeLanguage("th");
      }
      // Store the chosen language in local storage
      localStorage.setItem('storeid', chooselang);
    }
  }, [chooselang]);

  const updateLanguage = (lang) => {
    if (lang === 1) {
      i18n.changeLanguage("en");
    } else if (lang === 2) {
      i18n.changeLanguage("th");
    }

    dispatch({
      type: "LG__CHANGE",
    });

    localStorage.setItem("storeid", lang);
    setChooseLang(lang);
  };

  // Define the error style inline
  const errorStyle = {
    backgroundColor: 'rgba(255, 245, 245, 1)',
    border: '1px solid red !important'
  };

  // Mobile View singin, signup redirection
  const loginPage = currenturl + '/login';
  const handleSignUp = () => {
    // history.push('https://register.jagota.com/?lang=' + chooselang);
    window.location.href = 'https://register.jagota.com/?lang=' + chooselang;
  };
  const handleSignIn = () => {
    history.push('/login', { from: location.pathname });
  };

  const handleLoginWithOtp = async (e) => {
    e.preventDefault();
    history.push('/send-otp');
  };

  const hasErrors = errors?.username || errors?.password;

  // Determine left content based on whether it's reset password or login page
  const leftContent = id && tok ? (
    <>
      <div className='left_heading'>{t("Discover The World")}</div>
      <div className='left_info'>
        {t("We offer real solution for your daily operation")}
      </div>
    </>
  ) : (
    <>
      <div className='left_heading'>{t("Discover The World")}</div>
      <div className='left_info'>{t("Embark on a global")}</div>
    </>
  );


  // Right content remains the same
  const rightContent = (
    <>
      <div className={`right_content ${hasErrors ? 'error-present' : ''}`}>
        {id && tok ? (
          // Show Reset Password Component if id and tok are present
          <ResetPassword id={id} tok={tok} />
        ) : emailModal ? (
          <ForgotPassword onClose={() => setEmailModal(false)} />
        ) : (
          <>
            <div className="login_right_content_mobile">
              <button type='button' className='signupbutton active' onClick={handleSignIn}>{t('SIGN_IN')}</button>
              <button type='button' className='signinbutton' onClick={handleSignUp}>{t('SIGN_UP')}</button>
            </div>
            <div className="right_content_row">
              <div className="welcome_text">{t("WELCOME_TO_JAGOTA_ONLINE")} </div>
              <div className="welcome_info">{t("ENJOY_SHOPPING_WITH_US")}</div>
            </div>
            <div className="right_content_row">
              <div className="signin_text">{t("SIGN_IN")}</div>
              <div className="new_user_text">{t("NEW_USER")}
                <span> &nbsp;
                  <a href={`https://register.jagota.com?lang=${chooselang}`}>
                    {t("CREATE_AN_ACCOUNT")}
                  </a>
                </span></div>
            </div>
            <div className="right_content_row">
              <div className={`right_username ${errors?.username ? 'error-input' : 'blank-input'}`}>
                <FormInput
                  name="username"
                  type="text"
                  autoComplete="username"
                  style={errors?.username ? errorStyle : {}}
                  aria-labelledby="username"
                  label={t("Email address/ Mobile number")}
                  onChange={(e) => {
                    setusername(e.target.value);
                    seterrors((data) => ({
                      ...data,
                      username: "",
                    }));
                  }}
                  required />
              </div>
              {errors?.username && (
                <span className="loginpage__alert">{errors.username}</span>
              )}
              <div className={`right_password ${errors?.password ? 'error-input' : 'blank-input'}`}
                style={errors?.password ? errorStyle : {}}>
                <PasswordField
                  label={t("Password")}
                  autoComplete="current-password"
                  aria-labelledby="password"
                  style={errors?.password ? errorStyle : {}}
                  onChange={(e) => {
                    setpassword(e.target.value);
                    seterrors((data) => ({
                      ...data,
                      password: "",
                    }));
                  }}
                  name="password"
                  required
                />
              </div>
              {errors?.password && (
                <p className="loginpage__alert">{errors.password}</p>
              )}
            </div>
            <div className="right_content_col">
              <div className="right_checkbox">
                <Form.Group className="mb-3 form_check_box" controlId="formBasicCheckbox">
                  <Form.Check type="checkbox" label={t("REMEMBER_ME")} />
                </Form.Group>
              </div>
              <div className="right_forget_pwd" >
                <button onClick={() => setEmailModal(true)}>{t("FORGOT_PASSWORD")}</button></div>
            </div>
            <div className="right_content_row">
              <button type="submit" className="login__button" onClick={(e) => SubmitHandler(e)}>
                {t("SIGN_IN")}</button>
              {alert ? (<p className="loginpage__alert">{t("Invalid Username or Password")}</p>) : ("")}
            </div>
            <div className="right_content_row">
              <div className='social_login'>
                <div className='social_login_heading'>{t('Login with your social account')}</div>
                <div className='social_login_icon'>
                  <div className='social_login_line'>
                    <button onClick={handleLineLogin} className="line-login-btn icon-btn">
                      <i class="fab fa-line"></i>
                    </button>
                  </div>
                  <div class="divider"></div>

                  <div className="social_login_fb icon-btn">
                    <FacebookLogin
                      appId={request.REACT_APP_FB_APP_ID}
                      autoLoad={false}
                      textButton=""
                      shape="circle"
                      fields="name,email,picture"
                      callback={responseFacebook}
                      icon="fa-facebook"
                      cssClass="hidden-fb-button"
                      render={(renderProps) => (
                        <button onClick={renderProps.onClick} className="facebook-login-btn" >
                          <i className="fab fa-facebook"></i>
                        </button>
                      )}
                    />
                  </div>

                  <div class="divider"></div>

                  {/* Google Login */}
                  <div className="social_login_google">
                    <GoogleOAuthProvider clientId={request.REACT_APP_GOOGLE_CLIENT_ID}>
                      <GoogleCustomButton />

                    </GoogleOAuthProvider>
                  </div>
                </div>
              </div>
            </div>

            <div className="right_content_row">
              <button type="button" className="login__button" onClick={(e) => handleLoginWithOtp(e)}>
                {t("Existing Customer")}</button>
            </div>

            <div className="right_content_row">
              <div className="login_footer">
                <div className='footer-line-1'> {t('COUNTRY/REGION')} :
                  <select value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                    <option value="thailand">{t('THAILAND')}</option>
                    {/* <option value="english">English </option> */}
                  </select>
                </div>
                <button
                  className={`${chooselang === 2 ? "selected" : "footer-line-2"} lang-btn`}
                  onClick={() => updateLanguage(2)}>
                  <img src={Thailand} alt="Thailand" style={{ width: '30px', height: '20px' }} />
                </button>
                <button
                  className={`${chooselang === 1 ? "selected" : "footer-line-3"} lang-btn`}
                  onClick={() => updateLanguage(1)}>
                  <img src={English} alt="English" style={{ width: '30px', height: '20px' }} />
                </button>
              </div>
            </div>
          </>)}
      </div>
    </>)


  const termsAndPrivacyPolicy =
    show ? (
      <Modal show={show} size="lg" className={`${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`} style={{ overflow: "hidden", maxHeight: '100vh' }
      } >
        <Modal.Header>
          <Modal.Title>{t("Terms and Conditions")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-grid align-items-left justify-content-left modalbody">
          <div className="overflow-scroll mainbody">
            <p className={`${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>{t("Our desire to do better and be the best drives the passion and commitment behind everything we do. Therefore it is our passion and commitment to excellence that has established JAGOTA as one of the most creative and innovative companies in Thailand today, bringing trend setting and bespoke food solutions.")}</p>
            <p className={`${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>{t("As a dedicated company, we are constantly evolving with new ideas, concepts, events and solutions that further drive the success of our customers wherever they are and whatever their business, Modern Trade, Food Service, Catering, E-commerce… In this fiercely competitive market, we are constantly learning, from our environment, customer’s needs, market trends… and growing in the process, to consistently delight")}</p>
          </div>
          <div className="termsmsg">
            <input type="checkbox" id="acceptcheck" onChange={(e) => termsCheck(e.target.checked)} />
            <p className={`${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>{t("I have read and agree terms and condition")}  <span style={{ fontSize: "20px" }}>*</span></p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => AGREETERMS(dispatch, history, browserName, browserVersion)}
            id="regclosemodal"
            style={{ borderRadius: "unset", backgroundColor: "#37bfa7", border: "none" }}
            disabled={!checkingTerms}
            className={`${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>
            {t("Agree")}
          </Button>
        </Modal.Footer>
      </Modal >
    ) : null


  return <LoginComponent leftContent={leftContent} rightContent={rightContent} termsAndPrivacyPolicy={termsAndPrivacyPolicy} />;
}

export default LoginPage;
